import { render, staticRenderFns } from "./PendingCustomersAside.vue?vue&type=template&id=19592546&scoped=true&"
import script from "./PendingCustomersAside.vue?vue&type=script&lang=js&"
export * from "./PendingCustomersAside.vue?vue&type=script&lang=js&"
import style0 from "./PendingCustomersAside.vue?vue&type=style&index=0&id=19592546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19592546",
  null
  
)

export default component.exports